
import { Loading } from "element-ui";

export default {
data() {
return {
showLoading: false,
loadText: '订单生成中',
isDisable:false,
pzzypatients:'',
pzzydoctor:'',
dosageform:'yt1002',
totaldosage:'',
remark:'',
istiaofang:'',
value: true,
photo: {
sz: [], //照片
},
deletePhoto: [],
message: {}
};
},
created: function() {
document.title="拍方抓药";

this.messages = this.$store.state.AllOfValue.ImDoctorInfo;
this.pzzypatients=this.$store.state.basePzzy.jiuzhenren ||{};
this.pzzydoctor=this.$store.state.basePzzy.yishi || {};
this.dosageform=this.$store.state.basePzzy.dosageformCode||'yt1002';
this.totaldosage=this.$store.state.basePzzy.totaldosage||'';
this.remark=this.$store.state.basePzzy.patientRemark||'';
this.photo.sz=this.$store.state.basePzzy.imagesUrl||[];
this.userInfo = this.$store.state.userInfo;




this.$isLogin(window.location.search.substr(1), this.inits);
},
methods: {

inits() {
this.userInfo = this.$store.state.userInfo;
this.photoUrl = this.$store.state.userInfo.headphoto;
this.name = this.$store.state.userInfo.patientname;
this.phone = this.$store.state.userInfo.telephone;
},
chooseImg(e) {
if(e.target.files[0].type.indexOf('video') > -1){
this.$toastMsg('仅支持图片上传');
return false;
}
var _this = this;
var type = e.srcElement.attributes.uptype.nodeValue;
var formData = new FormData();
formData.append("file", e.target.files[0]);
var _this = this;
let loadingInstance = Loading.service({
text: "正在上传",
background: "rgba(0, 0, 0, 0.7)"
});
this.$doRequest(
{
url: "/api/FastDfs/uploadLocal",
catchs: function(err) {
_this.$nextTick(() => {

loadingInstance.close();
});
_this.$toastMsg('上传失败')
}
},
formData,
res => {
_this.$nextTick(() => {

loadingInstance.close();
});
_this.photo[type].push({
url: res[0].fileUrl,
fileurl: "/api/StaticFile/fastdfsLocalURL/" + res[0].fileUrl

});
},
null,
null,
true
);
},
del(e) {
var _this = this;
var type = e.srcElement.attributes.uptype.nodeValue;
var durl = e.srcElement.attributes.durl.nodeValue;
var newphoto = [];
this.deletePhoto.push(durl);
for (var i = 0; i < _this.photo[type].length; i++) {
if (_this.photo[type][i].url != durl) {
newphoto.push(_this.photo[type][i]);
}
}
_this.photo[type] = newphoto;
},
success() {
this.isDisable=true;
setTimeout(()=>{
this.isDisable=false   
},2000)
var _this = this;
var  totaldosage=this.totaldosage;
var  dosageform=this.dosageform;
var accordingTtongue = [];
for (var i = 0; i < _this.photo.sz.length; i++) {
accordingTtongue.push(_this.photo.sz[i].url);
}

if (this.$store.state.basePzzy.jiuzhenren==undefined) {
_this.$toastMsg("请选择就诊人");
return false;
}
if (this.$store.state.basePzzy.yishi==undefined) {
_this.$toastMsg("请选择医师");
return false;
}
if (accordingTtongue.length < 1) {
_this.$toastMsg("请完善药方照片");
return false;
}
if (totaldosage==''||totaldosage=='0'||totaldosage=='0.00') {
_this.$toastMsg("请完善剂量");
return false;
}
if (dosageform=='') {
_this.$toastMsg("请选择剂型");
return false;
}
_this.showLoading=true;

this.$doRequest(
"/api/orderJob/createOrderJob",
{
totaldosage:this.totaldosage,
dosageformCode:this.dosageform,
patientRemark:this.remark,
patientId:this.$store.state.basePzzy.jiuzhenren.id,
doctorId:this.$store.state.basePzzy.yishi.id,
imagesUrl: accordingTtongue,
},
res => {
_this.$store.state.basePzzy={};
_this.showLoading=false;
_this.$toastMsg("工单提交成功");
_this.$router.push({path:'/myManage'});

}
);

},

addPatient(){
if(this.$store.state.userInfo.telephone==null||this.$store.state.userInfo.telephone==''){
this.$toastMsg("请先完善患者信息");
this.$router.push({path: '/boundPhone'});
}else {
let message={
totaldosage:this.totaldosage,
dosageformCode:this.dosageform,
patientRemark:this.remark,
imagesUrl: this.photo.sz,
jiuzhenren:this.$store.state.basePzzy.jiuzhenren,
yishi:this.$store.state.basePzzy.yishi,
};
this.$store.state.basePzzy=message;
this.$router.push({path: '/pzzypatientEdit',query: {id: this.userInfo.id}});
}
},


addDoctor(){
if(this.pzzypatients.id==null||this.pzzypatients.id==''){
this.$toastMsg("请选择就诊人");
return;
}
let message={
totaldosage:this.totaldosage,
dosageformCode:this.dosageform,
patientRemark:this.remark,
imagesUrl:this.photo.sz,
jiuzhenren:this.$store.state.basePzzy.jiuzhenren,
yishi:this.$store.state.basePzzy.yishi,
};
this.$store.state.basePzzy=message;
this.$router.push({path: '/pzzydoctorEdit',query: {id: this.userInfo.id}});
},
updateTop(){
window.scroll(0,0);
},
}
};



// WEBPACK FOOTER //
// ./src/views/pzzyManage/index.vue